import { useState } from "react";
import { FaSearchPlus, FaTimes } from "react-icons/fa";
import "../../styles/code/TrainingCooperationSection.css";

const images = Array.from(
  { length: 18 },
  (_, i) => `/images/cooperation/${i + 1}.webp`
);

function TrainingCooperationSection() {
  const [lightboxImage, setLightboxImage] = useState(null);

  const openLightbox = (src) => {
    setLightboxImage(src);
    document.body.style.overflow = "hidden"; // khóa scroll
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    document.body.style.overflow = "auto";
  };

  return (
    <section className="training-cooperation-section section-container">
      <h2 className="section-title">
        <span className="normal">Các hoạt động</span>{" "}
        <span className="highlight">hợp tác đào tạo</span>
      </h2>

      <div className="cooperation-grid">
        {images.map((src, index) => (
          <div
            className="cooperation-image-box"
            key={index}
            onClick={() => openLightbox(src)}
          >
            <img
              src={src}
              alt={`cooperation-${index + 1}`}
              className="cooperation-image"
            />
            <div className="cooperation-overlay">
              <FaSearchPlus className="cooperation-icon" />
            </div>
          </div>
        ))}
      </div>

      {lightboxImage && (
        <div
          className="lightbox"
          onClick={closeLightbox}
        >
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span
              className="lightbox-close"
              onClick={closeLightbox}
            >
              <FaTimes />
            </span>
            <img
              src={lightboxImage}
              alt="enlarged"
              className="lightbox-image"
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default TrainingCooperationSection;
